// extracted by mini-css-extract-plugin
export var carrierIcon = "_x6-0";
export var carrierLogo = "_x6-1";
export var detailsSection = "_x6-2";